import axiosInstance from "../axiosMiddleware";

// export const getRelaxationReport = async ({ coachId }) => {
//   // 1. Get the ID and ensure it's a valid number
//   const rawStudentId = localStorage.getItem("studentid");
//   const studentId = rawStudentId ? Number(rawStudentId) : null;

//   // 2. Validate before sending to prevent the "value must contain" error
//   if (!coachId && !studentId) {
//     throw new Error("Identification missing: coachId or studentId required.");
//   }

//   try {
//     const response = await axiosInstance.get(`/relaxation-report/get-report`, {
//       // Ensure we don't send undefined/null keys if they don't exist
//       ...(coachId && { coachId: Number(coachId) }),
//       ...(studentId && { studentId })
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching relaxation reports:", error);
//     throw error;
//   }
// };



export async function getRelaxationReport(userID) {
  try {
    const response = await axiosInstance.get('relaxation-report/get-report', { params: userID });

    console.log("🤣🤣🤣🤣",response);
    

    return response.data;
  } catch (error) {
    console.error('Error fetching report data:', error);
    throw error;
  }
}

